"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InpostWidget = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const script_1 = __importDefault(require("next/script"));
const react_1 = require("react");
const INPOST_ACTION = 'onInpostPointSelect';
function InpostWidget({ token, handleOnPointSelect, }) {
    const domain = getGeowidgetDomain(token);
    const script = `${domain}/inpost-geowidget.js`;
    const [ready, setReady] = (0, react_1.useState)(() => widgetScriptLoaded(script));
    (0, react_1.useEffect)(() => {
        function onPointListener(event) {
            handleOnPointSelect(event.detail);
        }
        if (ready) {
            document.addEventListener(INPOST_ACTION, onPointListener);
        }
        return () => {
            document.removeEventListener(INPOST_ACTION, onPointListener);
        };
    }, [handleOnPointSelect, ready]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("style", { children: `
        @import url(${domain}/inpost-geowidget.css);
        inpost-geowidget {
          width: 100%;
          height: 500px;
        }` }), (0, jsx_runtime_1.jsx)(script_1.default, { src: script, strategy: "afterInteractive", onLoad: () => setReady(true) }), ready ? ((0, jsx_runtime_1.jsx)("inpost-geowidget", { onpoint: INPOST_ACTION, token: token, language: "pl", config: "parcelcollect" })) : ((0, jsx_runtime_1.jsx)(ui_1.Loading, {}))] }));
}
exports.InpostWidget = InpostWidget;
const INPOST_PROD_DOMAIN = 'https://geowidget.inpost.pl';
const INPOST_SANDBOX_DOMAIN = 'https://sandbox-easy-geowidget-sdk.easypack24.net';
function getGeowidgetDomain(token) {
    const [, base64] = token.split('.');
    const data = app_1.IS_SERVER
        ? Buffer.from(base64, 'base64').toString()
        : window.atob(base64);
    const { iss } = JSON.parse(data);
    return iss.includes('sandbox') ? INPOST_SANDBOX_DOMAIN : INPOST_PROD_DOMAIN;
}
function widgetScriptLoaded(domain) {
    return (!app_1.IS_SERVER && Boolean(document.querySelector(`script[src='${domain}']`)));
}
